// extracted by mini-css-extract-plugin
export var logo = "_kn-2";
export var logoWrapper = "_kn-1";
export var strip = "_kn-0";